module.exports = __webpack_public_path__ + "static/media/dz.3bb9af12.svg";